__turbopack_context__.v({
  "checkbox": "CheckBox-module-scss-module__1M3fpG__checkbox",
  "disabled": "CheckBox-module-scss-module__1M3fpG__disabled",
  "label": "CheckBox-module-scss-module__1M3fpG__label",
});
